/* eslint-disable react/no-array-index-key */
import { Text, View } from '@react-pdf/renderer';
import { ClaimsAdvice } from '../../../../models/pro.model';
import {
  formatAndRenderPdfTextContentHtml,
  getApplicableVesselTypesDisplay,
} from '../../../../utils/pro-report-helpers.utils';
import styles from '../../pro-report-pdf-styles';

interface LossPreventionCommentaryProps {
  claimsAdvice: ClaimsAdvice[] | undefined | null;
}

function NonVesselTypeSpecificLossPreventionCommentary({
  claimsAdvice,
}: LossPreventionCommentaryProps) {
  if (!claimsAdvice?.length) {
    return (
      <View style={styles.table}>
        <Text style={styles.tableCellFullWidth}>No advice provided.</Text>
      </View>
    );
  }

  return (
    <View style={styles.table}>
      {claimsAdvice.map((advice, idx) => (
        <View key={idx}>
          <View wrap={false} key={idx}>
            <Text style={styles.tableSubHeaderFullWidth}>
              <Text style={{ fontWeight: 700 }}>Applicable vessel types:</Text>{' '}
              {getApplicableVesselTypesDisplay(advice.applicable_vessel_types)}
            </Text>
            <Text style={styles.tableCellFullWidth}>
              <Text>
                <Text style={{ fontWeight: 700 }}>Summary:</Text>{' '}
                {formatAndRenderPdfTextContentHtml(
                  advice.summary,
                  'No summary provided.'
                )}
              </Text>
            </Text>
          </View>
          <View style={styles.tableCellFullWidth}>
            {formatAndRenderPdfTextContentHtml(
              advice.advice,
              'No advice provided.',
              {
                prependSubHeader: 'Advice:',
              }
            )}
          </View>
        </View>
      ))}
    </View>
  );
}

export default NonVesselTypeSpecificLossPreventionCommentary;
